import { useNavigate } from "react-router";
import {
  PATH_CONTACT,
  PATH_CONTACT_FORM,
  PATH_SERVICES_SECTION,
} from "../../../utility/constants";
import { SERVICES } from "../../../utility/utilityData";
import Button from "../../common/buttons/button/Button";
import SectionHeader from "../sectionHeader/SectionHeader";
import ServicesCard from "../servicesCard/ServicesCard";
import "./OurServicesSection.css";
import { CSSProperties } from "react";

type OurServicesSectionProps = {
  isHomePage?: boolean;
  style?: CSSProperties;
};

const OurServicesSection = ({ isHomePage, style }: OurServicesSectionProps) => {
  const navigate = useNavigate();
  return (
    <section id={PATH_SERVICES_SECTION} style={style}>
      <div className="app_section">
        {isHomePage && (
          <div className="appSection_header_container">
            <SectionHeader title={`⚡ Our Services`} />
            <h1 className="section_title">
              Comprehensive{" "}
              <span className="gradient_text"> Digital Solutions </span>
            </h1>
            <p className="section_description">
              From concept to deployment, we provide end-to-end development
              services that help your business thrive in the digital landscape.
            </p>
          </div>
        )}
        <div className="servicesCards_container">
          {SERVICES.map((service, index) => (
            <ServicesCard key={"ServicesCard" + index} service={service} />
          ))}
        </div>
        {isHomePage && (
          <div className="our_services_bottom_container">
            <p>Ready to bring your Project to life</p>
            <Button
              title="Discuss Your Project"
              onClickButton={() => navigate(PATH_CONTACT)}
              className="discuss_your_project_btn"
              backgroundColor="linear-gradient(135deg, hsl(214 84% 56%),hsla(214, 77%, 57%, 1.00), hsl(263 70% 50%))"
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default OurServicesSection;
